import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material'
import React from 'react'
import { FacebookProvider, Page } from "react-facebook";

interface Props {
  fbId: string;
}

const socialCard: React.FC<Props> = ({ fbId }) => {

  return (
    <Box
      sx={{
        mt: "35px",
        display: { xs: "none", md: 'flex' }
      }}
    >
      <Card sx={{ border: 0, boxShadow: 'none', width: "100%" }}>
        <Typography className="txt-bold" sx={{ fontSize: '20px' }}>
          Facebook Page
        </Typography>
        <CardContent sx={{ border: 0, px: 0 }}>
          <Box className="facebook-img">
            <FacebookProvider appId="1107205800174708">
              <Page
                href={fbId}
                tabs="timeline"
                adaptContainerWidth={true}
              />
            </FacebookProvider>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default socialCard;